import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/common/Footer.css';

const Footer = ({ image, text, shouldDecorate = false }) => {
  const renderText = () => {
    if (!shouldDecorate) return text;

    const words = text.trim().split(' ');
    if (words.length < 1) return text;

    const lastWord = words.pop();
    const remainingText = words.join(' ');

    return (
      <>
        {remainingText}{' '}
        <span className="footer__decorated-word">{lastWord}</span>
      </>
    );
  };

  const navLinks = [
    { name: 'Учням', href: '/theme/fractions' },
    { name: 'Вчителям', href: '/teachers' },
    { name: 'Батькам', href: '/parents' },
    { name: 'Команда проєкту', href: '/https://ed-era.com' },
  ];

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <h2 className="footer__title">{renderText()}</h2>
          
          <nav className="footer__nav">
            <ul className="footer__nav-list">
              {navLinks.map((link) => (
                <li key={link.name} className="footer__nav-item">
                  <Link to={link.href} className="footer__nav-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <p className="footer__copyright">
            © 2014–{new Date().getFullYear()} Educational Era
          </p>
        </div>

        {image && (
          <div className="footer__image-wrapper">
            <img src={image} alt="Footer decoration" className="footer__image" />
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;